// extracted by mini-css-extract-plugin
module.exports = {"searchBarWrapper":"SearchFilter_searchBarWrapper__3YVj-","searchIcon":"SearchFilter_searchIcon__-4XWs","searchBar":"SearchFilter_searchBar__2F_hc"};